import { render } from "./StackedGraphics.vue?vue&type=template&id=4f2a8d87"
import script from "./StackedGraphics.vue?vue&type=script&lang=js"
export * from "./StackedGraphics.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__